import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
import { socket } from '../../../../index';
import * as actionTypes from "../../../sc-core/Auth/store/actionTypes";
import config from "../../../../config/config";
import { download } from "../../../sc-utilities/download.utils";
import * as snackbarActions from "../../../sc-utilities/snackbar/store/snackbarActions";
import { COLLI } from "../../../sc-utilities/snackbar/store/actionTypes";
import snackbarStore from "../../../../snackbarStore";

// FOR LOCAL TESTING ONLY
//
// import io from "socket.io-client";
// import config from "../../../../config/config";
// const socket = io(`${config.backend_domain}:3001`, { transports: ["websocket"] });

// const updateDownloadProgress = progress => {

//     return {
//         type: 'DOWNLOAD|DOWNLOAD_PROGRESS',
//         downloadProgress: progress.downloadProgress,
//         maxSize: progress.maxSize,
//         currentSize: progress.currentSize,
//         snackBar: progress.snackBar,
//         data: progress,
//         name: progress.name
//     };
// };

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'colli',
    pluginName: 'LOGISTIC',
    entityName: 'COLLI',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    fetchSuccessUseBackendMessage: false,
    fetchFailedUseBackendMessage: false,
    createSuccessUseBackendMessage: true,
    createFailedUseBackendMessage: true,
    deleteSuccessUseBackendMessage: false,
    deleteFailedUseBackendMessage: false,
    loadSuccessUseBackendMessage: false,
    loadFailedUseBackendMessage: false,
    editSuccessUseBackendMessage: false,
    editFailedUseBackendMessage: false,
    bulkDeleteSuccessUseBackendMessage: false,
    bulkDeleteFailedUseBackendMessage: false,
});

// Fetch Colli action creators
export const fetchColliInit = () => {
    return crudActions.fetchInit();
};
export const fetchColliStart = () => {
    return crudActions.fetchStart();
};
export const fetchColliSuccess = (fetchColliCount, listColliCount) => {
    return crudActions.fetchSuccess(fetchColliCount, listColliCount);
};
export const fetchColliFail = () => {
    return crudActions.fetchFail();
};


export const countColli = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let countRes = await rest.post("colli/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data

            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch collies."}`,
                options: {
                    variant: 'warning'
                }
            });
            dispatch(fetchColliFail());

            return 0
        } catch (error) {
            dispatch(fetchColliFail());

            snackActions.snackBar({
                message: `${error.message || "Cannot fetch collies."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0
        }
    };
};

export const fetchColli = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchColliStart());
        try {
            let listRes = await rest.post("colli/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchColliSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            else {
                return []
            }
        }
        catch (error) {
            dispatch(fetchColliFail());

            return []
        }
    };
}
export const fetchCollies = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post("/colli/list", { listAll: true, ...params });
            if (res.data && res.data.succeeded) {
                let collies = [];
                for (var collie of res.data.result.data) {
                    collies.push({
                        value: collie.ColliID,
                        displayValue: `${collie.Name} (${collie.ColliInventoryID})`
                    });
                }
                return collies;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list collies "}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};


// export const fetchColli = filterData => {
//     const rest = getAxiosInstance();
//     return async dispatch => {
//         dispatch(fetchColliStart());
//         try {
//             let countRes = await rest.post("colli/count", filterData);
//             if (countRes.data && countRes.data.succeeded) {
//                 let listRes = await rest.post("colli/list", filterData);
//                 if (listRes.data && listRes.data.succeeded) {
//                     dispatch(fetchColliSuccess(countRes.data.result.data, listRes.data.result.data));
//                     return { data: listRes.data.result.data, count: countRes.data.result.data }
//                 }
//             }
//             dispatch(fetchColliFail());
//             snackActions.snackBar({
//                 message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch collies."}`,
//                 options: {
//                     variant: 'warning'
//                 }
//             });
//             return { data: [], count: 0 };
//         } catch (error) {
//             dispatch(fetchColliFail());
//             snackActions.snackBar({
//                 message: `${error.message || "Cannot fetch collies."}`,
//                 options: {
//                     variant: 'error'
//                 }
//             });
//             return { data: [], count: 0 }
//         }
//     };
// };

// Create colli  action creators
export const createColliInit = () => {
    return crudActions.createInit();
};
export const createColliStart = () => {
    return crudActions.createStart();
};
export const createColliSuccess = colli => {
    return crudActions.createSuccess(colli);
};
export const createColliFail = error => {
    return crudActions.createFail(error);
};

export const createColli = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createColliStart());
        try {
            let res = await rest.post('/colli/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created colli.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createColliFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create colli."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create colli."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createColliFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// load colli
export const loadColliInit = () => { return crudActions.loadInit(); };
export const loadColli = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

// Edit colli  action creators
export const editColliInit = () => {
    return crudActions.editInit();
};
export const editColliStart = () => {
    return crudActions.editStart();
};
export const editColliSuccess = colli => {
    return crudActions.editSuccess(colli);
};
export const editColliFail = error => {
    return crudActions.editFail(error);
};


export const editColli = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editColliStart());
        try {
            let res = await rest.post('/colli/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated colli.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editColliFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit colli."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit colli."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editColliFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete colli 
export const bulkDeleteColliesInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteColliesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteColliesSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteColliesFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteCollies = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteColliesStart());
        try {
            let res = await rest.post('/colli/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteColliesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted collies ${params.Name}.`,
                    options: {
                        variant: 'success'
                    }
                });
                return true
            }
            dispatch(bulkDeleteColliesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete collies."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete collies."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteColliesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Grades fetch
export const fetchGrades = (data, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/grades/list', { listAll: true, ...data }, options);
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    grades.push({ value: grade.GradeID, label: grade.InternationalGrading });
                }
                return grades;
            }
            else {
                if (res && res.canceled) {
                    return [''];
                }
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list grades."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

// Colli type fetch
export const fetchColliType = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('colli/type/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const colliTypes = [];
                for (var colliType of res.data.result.data) {
                    colliTypes.push({ value: colliType.ColliTypeID, label: colliType.Name });
                }
                return colliTypes;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list coli types."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}


// collies
export const listCollies = (params, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/colli/list', { listAll: true, ...params }, options);
            if (res.data && res.data.succeeded) {
                const collies = [];
                for (var colli of res.data.result.data) {
                    collies.push({
                        value: colli.ColliID,
                        displayValue: `${colli.ColliInventoryID} - ${colli.Name}`,
                        holderColliTypes: colli.ColliType.ColliHolderTypes.map(type => type.ColliTypeID),
                        AllowHolderColliIDNull: colli.ColliType.AllowHolderColliIDNull
                    });
                }
                return collies;
            }
            else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const generateReport = (colli, translations) => {
    const rest = getAxiosInstance();
    return async _dispatch => {
        try {
            colli['SocketID'] = socket.id.split('#')[1];
            let res = await rest.post('/report/create-collection', colli);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: translations['create_collection_started'] || `Create collection started.`,
                    options: {
                        variant: 'success'
                    }
                });
                const redisTopic = res.data.result.data.RedisTopic;
                socket.on(redisTopic, async msg => {
                    const { Status, ErasureReportID, RedisTopic } = msg;
                    const { ColliInventoryID, Generated, ToGenerate, Message } = msg;
                    snackbarStore.dispatch(snackbarActions.showCollection({ type: COLLI, collection: { ColliInventoryID, Generated, ToGenerate } }));
                    if (Status === 'error') {
                        socket.off(RedisTopic);
                        snackbarStore.dispatch(snackbarActions.hideCollection({ type: COLLI, collection: { Generated, ToGenerate } }));
                        return snackActions.snackBar({
                            message: Message || translations['error_create_collection'] || `Error: Create collection failed. Please contact administrator.`,
                            options: {
                                variant: 'error'
                            }
                        });
                    }

                    if (Status === 'generated') {
                        const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${colli.ActiveCustomerID}`;
                        socket.off(RedisTopic);
                        snackbarStore.dispatch(snackbarActions.hideCollection({ type: COLLI, collection: { ColliInventoryID, Generated, ToGenerate } }));
                        await download(objUrl);
                        snackActions.snackBar({
                            message: translations['create_collection_finished'] || `Create collection finished.`,
                            options: {
                                variant: 'success'
                            }
                        });
                    }

                });
            } else {
                snackActions.snackBar({
                    message: translations['error_create_collection'] || `Error: Create collection failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['error_create_collection'] || `Error: Create collection failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

// Restore colli action creators
export const restoreColliInit = () => {
    return crudActions.editInit();
};
export const restoreColliStart = () => {
    return crudActions.editStart();
};
export const restoreColliSuccess = result => {
    return crudActions.editSuccess(result);
};
export const restoreColliFail = error => {
    return crudActions.editFail(error);
};

export const restoreColli = restoreData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(restoreColliStart());
        try {
            let res = await rest.post('/colli/restore', restoreData);
            if (res.data && res.data.succeeded) {
                dispatch(restoreColliSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully restored collies.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(restoreColliFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot restore collies."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot restore collies."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(restoreColliFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// list colli types
export const listWarehouse = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/warehouse/list', params);
            if (res.data && res.data.succeeded) {
                const warehouses = [];
                for (var warehouse of res.data.result.data) {
                    warehouses.push({
                        inventoryID: warehouse.WarehouseInventoryID,
                        value: warehouse.WarehouseID,
                        displayValue: warehouse.Name ? warehouse.Name : "-"
                    });
                }
                return warehouses;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];

        }
    };
};
export const setActiveWarehouseID = (data) => {
    return ({
        type: actionTypes.HANDLE_ACTIVE_WAREHOUSE,
        activeWarehouseID: data.ActiveWarehouseID
    });
};

// list colli types
export const setActiveWarehouse = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/users/set-active-warehouse', params);
            if (res.data && res.data.succeeded) {
                dispatch(setActiveWarehouseID(params))
                return res.data.succeeded
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;

        }
    };
};


// list colli types
export const listColliTypes = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/colli/type/list', params);
            if (res.data && res.data.succeeded) {
                const colliTypes = [];
                for (var colliType of res.data.result.data) {
                    colliTypes.push({
                        value: colliType.ColliTypeID,
                        displayValue: colliType.Name ? colliType.Name : "-",
                        allowHolderColli: colliType.AllowHolderColliIDNull
                    });
                }
                return colliTypes;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];

        }
    };
};

export const listProductTypes = (params, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/product-type/list', params, options);
            if (res.data && res.data.succeeded) {
                const productTypes = [];
                for (var productType of res.data.result.data) {
                    productTypes.push({
                        value: `${productType.ProductTypeID}`,
                        label: `${productType.Name}`,
                        key: `${productType.Key}`
                    });
                }
                return productTypes.sort((a, b) => a.label.localeCompare(b.label));
            }
            else {
                if (res && res.canceled) {
                    return [''];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};


